import { useEffect, useState } from 'react'

import { useSessionContext } from 'hooks/SessionContext'

import Api from 'services/api'

import { CustomerAdoption } from 'types/CustomerAdoption'

const useCustomerAdoption = () => {
  const { session: { dealerId } } = useSessionContext()
  const [customers, setCustomers] = useState<Array<CustomerAdoption> | null>(null)
  const [areCustomersLoaded, setAreCustomersLoaded] = useState(false)

  useEffect(() => {
    if (!dealerId) {
      setAreCustomersLoaded(true)

      return
    }

    Api.CustomerAdoption.get(dealerId)
      .then((res : Array<CustomerAdoption> | null) => {
        setCustomers(res)
      })
      .catch(() => {
        setCustomers(null)
      })
      .finally(() => {
        setAreCustomersLoaded(true)
      })
  }, [dealerId])

  return { customers, areCustomersLoaded }
}

export default useCustomerAdoption
